import { CheckoutSegmentCategory } from "@redotech/redo-conversion-core-common/conversion/checkout-segments/checkout-segment-category";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/** One bucket constraint in a recommended sub-segment (e.g. "Repeat customers"). */
const recommendationDimensionSchema = z.object({
  category: createEnum(CheckoutSegmentCategory),
  bucketKey: z.string(),
  bucketName: z.string(),
});

const segmentRecommendationSchema = z.object({
  dimensions: z.array(recommendationDimensionSchema),
  label: z.string(),
  recommendedTreatmentId: z.string(),
  recommendedTreatmentName: z.string(),
  controlRevenuePerVisit: z.number(),
  variantRevenuePerVisit: z.number(),
  lift: z.number(),
  liftCiLower: z.number(),
  relativeLift: z.number(),
  adjustedPValue: z.number(),
  significant: z.boolean(),
  projectedIncrementalRevenue: z.number(),
  segmentVisits: z.number(),
  controlVisits: z.number(),
  variantVisits: z.number(),
  minDetectableEffect: z.number(),
});

export type SegmentRecommendationOutput = z.infer<
  typeof segmentRecommendationSchema
>;

/** Top positive-lift sub-segments (variant beats control on revenue/visit), each flagged significant or not. */
export const getRecommendationsForSplitBySegment = {
  name: "getRecommendationsForSplitBySegment" as const,
  input: z.object({ splitId: z.string() }),
  output: z.object({ recommendations: z.array(segmentRecommendationSchema) }),
};
export type GetRecommendationsForSplitBySegmentOutput = z.infer<
  typeof getRecommendationsForSplitBySegment.output
>;
